module.exports = __webpack_public_path__ + "img/zanwu.07e7f448.png";